import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { backLinkTag } from '@ui/elementTags';
import { applyNhsGlobal } from '@ui/styles/applyNhsGlobal';
import backLinkStyles from '@ui/styles/nhs-subsets/nhs-backlink.scss?inline';

export interface BackLinkViewModel {
  href: string;
  text: string;
  visible: boolean;
}

@customElement(backLinkTag)
export class BackLinkComponent extends LitElement {
  @property({ attribute: false })
  public viewModel?: BackLinkViewModel;

  protected createRenderRoot(): HTMLElement | ShadowRoot {
    return applyNhsGlobal(this, backLinkStyles);
  }

  public render() {
    if (!this.viewModel?.visible) {
      return nothing;
    }

    return html`<a class="nhsuk-back-link" href=${this.viewModel.href} @click=${this.handleClick}>${this.viewModel.text}</a>`;
  }

  private readonly handleClick = (event: Event): void => {
    event.preventDefault();
    this.dispatchEvent(new CustomEvent('back-link-click', {
      bubbles: true,
      composed: true,
      detail: this.viewModel,
    }));
  };
}

declare global {
  interface HTMLElementTagNameMap {
    [backLinkTag]: BackLinkComponent;
  }
}